module.exports = __webpack_public_path__ + "static/media/JavaScript_logo.eeac7172.png";